/* eslint-disable */
// Here eslint disable is use to avoid line width error
import React from "react";

const LinePen = (props: { className?: string }) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
    <path d="M0,0H20V20H0Z" fill="none" />
    <path
      d="M4.556,15.445h1.1L12.9,8.2l-1.1-1.1L4.556,14.346ZM17,17H3V13.7L13.449,3.257a.778.778,0,0,1,1.1,0l2.2,2.2a.777.777,0,0,1,0,1.1l-8.894,8.89H17ZM12.9,6.006l1.1,1.1,1.1-1.1L14,4.907l-1.1,1.1Z"
      transform="translate(0)"
      fill="currentColor"
    />
  </svg>
);

export { LinePen };
